import { getChargebacks } from "@/services/disputes.service";
import { useQuery } from "@tanstack/react-query";

export const useChargebacks = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "chargebacks",
    params.page,
    params.size,
    params.status,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getChargebacks(params),
    enabled,
    ...options,
  });
};
